import ApiService from '../api.services';

const PackingService = {
    list: async function (search, type) {
        try {
            const response = await ApiService.get(`/api/packing?search=${search}&type=${type}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    customers: async function (search) {
        try {
            const response = await ApiService.get(`/api/packing/customers/list?search=${search}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/packing/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (data) {
        try {
            const response = await ApiService.post('/api/packing', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, form) {
        const data = {
            packing: form
        }
        try {
            const response = await ApiService.put(`/api/packing/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/packing/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default PackingService;

export { PackingService };

